/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import {
  EntitiesModel,
  isNotUndefined,
  PaginationModel,
} from '@lm-nx-frontend/lm-inf-core';

import { TableService } from '@lm-nx-frontend/lm-inf-ui';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ListService } from '../../shared/list/list.service';
import { OrganizationTableType } from '../../shared/organization.model';
import {BudgetService} from "../../../core/services";
import {Budget} from "../../../core/model";

/**
 * Service to populate Budget data to `Table` data. Budget
 * data is driven by the table configuration, using the `OrganizationTables.BUDGET`.
 */
@Injectable({
  providedIn: 'root',
})
export class BudgetListService extends ListService<Budget> {
  protected tableType = OrganizationTableType.BUDGET;

  constructor(
    protected tableService: TableService,
    protected budgetService: BudgetService
  ) {
    super(tableService);
  }

  protected load(
    pagination: PaginationModel
  ): Observable<EntitiesModel<Budget>> {
    return this.budgetService.getList(pagination).pipe(
      filter(isNotUndefined),
      map((raw) => this.convertBudgets(raw))
    );
  }

  /**
   * Populates budget data to a convenient table data model, so that we
   * can skip specific conversion in the view logic where possible.
   */
  protected convertBudgets({
    pagination,
    sorts,
    values,
  }: EntitiesModel<Budget>): EntitiesModel<Budget> {
    const budgetModels: EntitiesModel<Budget> = {
      pagination,
      sorts,
      values: values.map((value: any) => ({
        ...value,
        currency: value.currency?.isocode,
        unit: value.orgUnit,
      })),
    };
    return budgetModels;
  }
}
